import * as React from 'react';
import { useState, useEffect } from 'react'
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { getAuthData, getCurrentUser, setAuthData } from '../services/selectors/Accounts';
import { getCookie, handleTime, showAlert } from './common/functions';
import { Spinner } from 'reactstrap';
import { episodeAction } from '../actions/episodeAction';
import { DABInlineLoading } from '../components/dab';
import { userAction } from '../actions/userAction';
import { azureAction } from '../actions/azureAction';
import AzureUserMetrics from '../components/dab/azureUserMetrics';
import UserEpisodeMetrics from '../components/dab/UserEpisodeMetrics';
import SettingService from '../services/api/settingService';

interface IHomePageProps {
	dispatch: Dispatch<any>;
	loginData: any;
	userData: any;
	callback: any;
	episodeData: any;
	EpisodeAvailabiltyDaysCheck: any
}

export const dashboardListConstants = {
	"videoHotline": "video-hotline",
	"testimonial": "testimonial",
	"dabFilms": "dab-films",
	"contextualMedia": "contextual-media"
}

const Home: React.SFC<IHomePageProps> = ({ dispatch, loginData, episodeData, userData }) => {

	const [isLogged, setIsLogged] = useState(false);
	const [userRoles, setUserRoles] = useState('');
	const memoryRoute = sessionStorage.getItem('memoryRoute');
	const fromPath = sessionStorage.getItem('fromPath');
	const [dashboardListData, setDashboardListData] = useState([])
	const isAdmin = userRoles.includes('Admin');
	const isCommunity = userRoles.includes('Community');
	const isEpisode = userRoles.includes('Episode');
	const isCommunityManagerOnly = isCommunity && !isAdmin;
	const showCommunityManagement = isAdmin || isCommunity;
	const showEpisodeManagement = isAdmin || isEpisode;

	const communityManagerDashboardUniqueCodes = [
		dashboardListConstants.videoHotline,
		dashboardListConstants.testimonial,
	];
	const visibleDashboardList = isCommunityManagerOnly
		? (dashboardListData ?? []).filter((item: any) =>
				communityManagerDashboardUniqueCodes.includes(item?.uniqueCode)
			)
		: dashboardListData ?? [];

	useEffect(() => {
		sessionStorage.removeItem("createEpisode");
		const loggedInData = getAuthData();
		const refreshTokenValue = getCookie("refreshToken");
		if (fromPath) {
			sessionStorage.removeItem('fromPath');
		}
		if (loggedInData) {
			setIsLogged(true)
			dispatch(episodeAction.episodeValidateFeed());
		}
		const user = getCurrentUser();
		if (user != null && user.info?.roleCodes != null) {
			setUserRoles(user.info.roleCodes);
		}

		var alertMessage = window.localStorage.getItem('alertMessage');
		if (alertMessage && alertMessage !== "") {
			showAlert(alertMessage, false);
			window.localStorage.setItem('alertMessage', "");
		}
		document.title = "Daily Audio Bible Administration";

		const fetchDropdown = async () => {
			const dashboardData = await SettingService.getDashboardList();
			setDashboardListData(dashboardData.data);
			window.localStorage.setItem('dashboardListData', JSON.stringify(dashboardData.data));
		};
		fetchDropdown();
	}, [])

	if (loginData) {
		if (loginData.isSuccess && loginData.isRememberMeLoggedIn) {
			setAuthData(loginData);
			handleTime();
			window.location.href = memoryRoute ? memoryRoute : "/";
		}
	}
	const formatDate = () => {
		if (episodeData && episodeData.itemValue.inputDateAtUtc) {
			return episodeData.itemValue.inputDateAtUtc.split(" ")[0];
		}
	};

	const getUrlByuniqueCode = (status: any) => {
		switch (status) {
			case dashboardListConstants.videoHotline:
				return "/videohotline";
			case dashboardListConstants?.testimonial:
				return "/testimonial";
			case dashboardListConstants?.dabFilms:
				return "/dabfilms";
			case dashboardListConstants?.contextualMedia:
				return "/contextualmedia";
			default:
				return "/";
		}
	};
	return (
		<div>
			{isLogged ? <div>
				<h2 data-testid="homeText">DAB Administration Portal</h2>
				<br />
				<div className="home-container">
					<div className="col-left">
						{showEpisodeManagement && (
						<div>
							<h5 data-testid="homeBody" >Episode Management</h5>
							<ul>
								<li data-testid="createEpisode"><a href={"/episode?page=add"}>Create New Episode</a></li>
								{isAdmin && (
									<>
								<li data-testid="manageReadingPlan"><a href={"/readingPlan"}>Manage Reading Plans</a></li>
								<li data-testid="manageChannels"><a href={"/channel"}>Manage Channels</a></li>
								</>
								)}
							</ul>
						</div>
						)}
						{showCommunityManagement && (
						<div>
							<h5 data-testid="homeContent">Community Management</h5>
							<ul>
								<li data-testid="communityMemberDashboard"><a href={"/dashboard"}>Community Member Dashboard</a></li>
								<li data-testid="managePrayerWall"><a href={"/messageboard?page=topics&code=prayerwall"}>Prayer Wall</a></li>
								{isAdmin && (
									<>
										<li data-testid="manageMessageboard"><a href={"/messageboard"}>Manage Message Boards</a></li>
										<li data-testid="manageHotline"><a href={"/messageboard?page=topics&code=hotline"}>DAB Hotline</a></li>
										<li data-testid="manageChronologicalHotline"><a href={"/messageboard?page=topics&code=hotlinechronological"}>Chronological Hotline</a></li>
									</>
								)}
								{visibleDashboardList.map((item: any) => (
									<li data-testid={item?.uniqueCode} key={item?.messageBoardId}>
										<a href={getUrlByuniqueCode(item?.uniqueCode)}>{item?.title}</a>
									</li>
								))}
								{isAdmin && (
									<>
										<li data-testid="music"><a href={"/music"}>Music</a></li>
										<li data-testid="prayer"><a href={"/prayer-talks"}>Prayer/Meditation & Talks</a></li>
										<li data-testid="ratings"><a href={"/ratings"}>Rating List</a></li>
									</>
								)}
							</ul>
						</div>
						)}
					</div>

					<div className="col-right">
						{showEpisodeManagement && (
							<div data-testid="feedvalue">
								<h5 data-testid="chnlwithoutfeed">Episode Unavailability Status</h5>
								{episodeData && episodeData.isLoading ?
									<DABInlineLoading /> :
									<div className={episodeData.itemValue.feedExistsForAllChannels ? "" : "no-feed"} >
										<p className="dateformat" data-testid="date">
											Episode is not available for the following channels on
											<span> {formatDate()}</span>
										</p>
										{!episodeData.itemValue.feedExistsForAllChannels ?
											<ul className="episodefeed">
												{episodeData.itemValue.channelsWithoutFeed?.split(',').map((epsiodeId) => (
													<li key={epsiodeId}>
														<p data-testid="feedchnls">{epsiodeId.trim()}</p>
													</li>
												))}
											</ul>
											: <p className="dateformat" data-testid="date">Episode is available for all channels on {formatDate()}</p>}
									</div>
								}
							</div>
						)}
						{isAdmin &&
							<div>
								<h5 data-testid="managemodulesettings">Manage Module Settings</h5>
								<ul>
									<li data-testid="setting" className='my-2'><a href={"/settings"}>Settings</a></li>
									<li data-testid="resources" className='my-2'><a href={"/resources"}>Featured Resources</a></li>
									<li data-testid="appUpdateNotification" className='my-2'><a href={"/app-release-notification"}>App Release Notification</a></li>
									<li data-testid="manageRatingSettings" className='my-2'><a href={"/manage-rating-settings"}>Rating</a></li>
								</ul>
							</div>
						}

					</div>
				</div>
				<div>
					<AzureUserMetrics />
				</div>
				<div>
					<UserEpisodeMetrics />
				</div>
			</div> :
				<div className="loader" style={{ minHeight: window.innerHeight - 150 }}>
					<div>
						<Spinner type="grow" color="primary" />
						<Spinner type="grow" color="secondary" />
						<Spinner type="grow" color="success" />
						<Spinner type="grow" color="danger" />
						<Spinner type="grow" color="warning" />
						<Spinner type="grow" color="info" />
						<Spinner type="grow" color="light" />
						<Spinner type="grow" color="dark" />
					</div>
					<div className="text" id="modal-text">
						Processing...Please wait.
					</div>
				</div>}
		</div>
	);
}

const mapStateToProps = (state: any) => {
	const { loginData, episodeData, userData } = state;
	return {
		loginData,
		episodeData,
		userData
	};
};

export default connect(mapStateToProps)(Home);